import { Component, LabeledComponentDefinition } from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import template from "./text.hbs";

export class Text extends ValueBaseComponent<TextDefinition> implements Component {
    public componentType: "text";

    constructor(definition: TextDefinition) {
        super(definition);
        if (this.definition.width == null) {
            this.definition.width = 16;
        }
    }

    public render(): Element {
        let d = document.createElement("div");
        let message = Object.assign(
            { key: this.definition.labelKey },
            this.definition.values,
        );
        d.innerHTML = template({...this.definition, message});
        return d.firstChild as HTMLElement;
    }
}

export interface TextDefinition extends LabeledComponentDefinition {
    values: any[];
}

